<template>
  <svg
    width="977"
    height="977"
    viewBox="0 0 977 977"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8008_12756)">
      <ellipse
        cx="75.7481"
        cy="101.759"
        rx="75.7481"
        ry="101.759"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 614.033 470.124)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8008_12756"
        x="0.599457"
        y="0.599457"
        width="975.834"
        height="975.834"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="199.105"
          result="effect1_foregroundBlur_8008_12756"
        />
      </filter>
    </defs>
  </svg>
</template>
